import { useEffect } from 'react';
import { Redirect, useLocation } from 'react-router-dom';
import qs from 'query-string';
import useAuth from 'src/hooks/useAuth';
import {
  clearReturnUrl,
  isReturnUrlFresh,
  normalizeReturnUrl,
  readReturnUrl,
} from './returnUrl';

const GuestGuard = ({ children }) => {
  const location = useLocation();
  const {
    isAuthenticated,
    utilizandoAdfs,
    hybridAuthenticationEnabled,
    identityProviders,
    getLoginAdfs,
  } = useAuth();
  const windowLocation = window.location;
  const stateReturnUrl = isReturnUrlFresh(location?.state?.returnUrlCreatedAt)
    ? normalizeReturnUrl(location?.state?.from)
    : null;
  const isAdfsCallback = location.pathname.toLowerCase() === '/verifyadfs';
  const returnUrl = stateReturnUrl || (isAdfsCallback ? readReturnUrl() : null);

  const acessoExterno =
    windowLocation && qs.parse(windowLocation.search).externo
      ? qs.parse(windowLocation.search).externo === 'S'
        ? true
        : false
      : false;
  const isApp =
    windowLocation && qs.parse(windowLocation.search).isApp
      ? qs.parse(windowLocation.search).isApp === 'true'
        ? true
        : false
      : false;

  useEffect(() => {
    if (isAuthenticated && !acessoExterno) {
      clearReturnUrl();
    } else if (!acessoExterno && !stateReturnUrl && !isAdfsCallback) {
      clearReturnUrl();
    }
  }, [
    isAuthenticated,
    acessoExterno,
    stateReturnUrl,
    isAdfsCallback,
    location.pathname,
  ]);

  if (isAuthenticated && !acessoExterno) {
    return <Redirect to={returnUrl || '/'} />;
  } else if (
    utilizandoAdfs &&
    !hybridAuthenticationEnabled &&
    identityProviders?.length <= 1 &&
    acessoExterno === false &&
    location.pathname.toUpperCase() != '/VERIFYADFS' &&
    location.pathname.toUpperCase() != '/RELATORIO-AUTH' &&
    location.pathname.toUpperCase() != '/LOGOUT'
  ) {
    if (!returnUrl) clearReturnUrl();
    const idp = identityProviders[0]?.id;
    getLoginAdfs(isApp, idp);
  }

  return <>{children}</>;
};

export default GuestGuard;
